var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.invoiceUrl)?_c('iframe',{staticStyle:{"height":"92vh","width":"100%"},attrs:{"src":_vm.invoiceUrl,"frameborder":"0"}}):_c('noData')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }